import React, {Component} from 'react';
import swal from 'sweetalert';
import {translate} from 'react-i18next';
import SvgIcon from 'react-icons-kit';
import {database} from 'react-icons-kit/icomoon/database';
import Help from '../../generics/help';
import ModalDates from './ModalDates';

var Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class SpecialQueries extends Component{
    constructor(props){
        super(props);

        this.download = this.download.bind(this);
        this.openModal = this.openModal.bind(this);

        this.state = {
            queries:[]
        }

    }

    componentDidMount(){
        fetch(Config.default.apiGateway.URL+'direct_queries',{
            method:'GET',
            headers:new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            this.setState({queries: response})
        })
    }

    download(e, id, name, start_date="", end_date=""){
        fetch(Config.default.apiGateway.URL+'direct_queries/execute?id='+id+
            '&start_date='+start_date+'&end_date='+end_date,{
            method:'GET',            
            responseType: 'blob',
            headers:new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Content-Type'  : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
            })
        }).then(res => {
            if(res.ok){
                return res.blob();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                var fileURL = URL.createObjectURL(response);

                var downloadLink = document.createElement("a");
                downloadLink.href = fileURL;
                downloadLink.download = name+".xlsx";

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                
            }
            
        })
    }

    openModal(e, q){
        if(q.need_date_filters){
            this.modal_date.handleShow(q.id, q.report_name);
        }else{
            this.download(e, q.id, q.report_name);
        }
    }

    render(){
        const {t} = this.props;
        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes -> Reportes Especiales
					</h5>
				</div>

                <Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_direct_queries"}  />

                <div className="form-group">
                    <div className="col-xs-12 form-group" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
                        <span>
                            Reportes Especiales
                        </span>
                    </div>
                    {this.state.queries.map((q, i)=>(
                        <div key={i} className="col-xs-12 col-sm-4 col-md-2" style={{textAlign:'center'}}>
                            <div className="form-group">
                                {q.report_icon === null ?
                                    <SvgIcon size={60} icon={database} style={{cursor:'pointer'}}
                                        onClick={(e)=>this.openModal(e, q)}         
                                    />
                                :
                                    <img src={'data:image/jpeg;base64,'+q.report_icon}  style={{width:'35%', cursor:'pointer'}}
                                        onClick={(e)=>this.openModal(e, q)}
                                    />
                                }
                            </div>
                            <div>
                                <span className="span-min">{q.report_name}</span>
                            </div>
                        </div> 
                    ))}
                </div>

                <ModalDates download={this.download} onRef={ref => this.modal_date = ref} />
            </div>
        )
    }
}

export default translate('translations') (SpecialQueries);